export default __webpack_public_path__ + "static/media/por-document.f81c5e9f.png";